export const AUTH = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logoutBtn: "admin-logout-btn",
};

export const ADMIN = {
  dashboard: "admin-dashboard",
  bookingsTable: "admin-bookings-table",
  bookingRow: (id) => `admin-booking-row-${id}`,
  statusSelect: (id) => `admin-booking-status-${id}`,
  deleteBooking: (id) => `admin-booking-delete-${id}`,
};

export const BOOKING = {
  packageSelect: (id) => `booking-package-${id}`,
  vehicleSelect: (v) => `booking-vehicle-${v}`,
  dateInput: "booking-date-input",
  timeSelect: "booking-time-select",
  name: "booking-name-input",
  phone: "booking-phone-input",
  email: "booking-email-input",
  address: "booking-address-input",
  notes: "booking-notes-input",
  submit: "booking-submit-btn",
  estimate: "booking-estimate-total",
  successMsg: "booking-success-msg",
};
